import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { getAppConfig } from '../../app.config';
import { recordingHeaders } from './support-recording-requests';
import { SupportRecordingService } from './support-recording.service';

/**
 * During a support recording, sends the action id with every request to the admin API (GraphQL goes through
 * HttpClient via the FetchAdapter): x-phx-action, the same value as X-PHX-Config-Request-Id — nginx logs that
 * header already — and x-phx-recording with the id of the recording. Without them the backend records nothing
 * of the request.
 */
@Injectable()
export class SupportRecordingInterceptor implements HttpInterceptor {
    private readonly recorder = inject(SupportRecordingService);
    private readonly apiPath = `/${getAppConfig().adminApiPath}`;

    intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const recording = this.recorder.recording();
        if (!recording || !req.url.includes(this.apiPath)) return next.handle(req);
        return next.handle(req.clone({ setHeaders: recordingHeaders(this.recorder.actionIdForRequest(), recording) }));
    }
}
